import { Components, Theme } from '@mui/material/styles';

const typographyTheme: Components<Theme>['MuiTypography'] = {
  variants: [
    {
      props: { variant: 'popup-message' },
      style: ({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        margin: theme.spacing(1),
        border: `1px solid ${theme.palette.offGray}`,
        '& .MuiPaper-root': {
          textAlign: "center",
          background: theme.palette.offGray,
          color: theme.palette.neutralWhite,
          padding: theme.spacing(2),
          fontWeight: 'bold',
          fontFamily: theme.typography.fontFamily,
          '& > .MuiSvgIcon-root': {
            position: 'absolute',
            right: theme.spacing(4),
            cursor: 'pointer'
          }
        },
        '& > .MuiBox-root': {
          background: theme.palette.coldWhite,
          fontFamily: theme.typography.fontFamily,
          color: theme.palette.black,
          padding: theme.spacing(2)
        }
      }),
    },
    {
      props: { variant: 'document-hyperlink' },
      style: ({ theme }) => ({
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        '& > .MuiSvgIcon-root': {
          display: 'inline-block',
          fill: theme.palette.red[600],
          mx: theme.spacing(0.25),
        },
        '& > .MuiTypography-root, > .MuiListItemButton-root': {
          color: theme.palette.corporateBlue,
          fontFamily: theme.typography.fontFamily,
          fontWeight: 'normal',
          cursor: 'pointer',
          paddingLeft: 0,
          textDecoration: 'underline',
          '&:hover': {
            background: theme.palette.neutralWhite,
          }

        }
      }),
    },
    {
      props: { variant: 'availability-administration-card' },
      style: ({ theme }) => ({
        background: theme.palette.common.white,
        marginTop: theme.spacing(1),
        padding: theme.spacing(1),
        borderRadius: '4px',
        '& .number-wrapper': {
          background: theme.palette.common.white,
          marginBottom: theme.spacing(0.5),
          textAlign: 'center',
          '& > .MuiBox-root > .MuiTypography-root': {
            fontFamily: theme.typography.fontFamily,
            color: theme.palette.black,
          },
          '& .MuiFormControl-root.MuiTextField-root': {
            borderColor: theme.palette.warmBlue,
            fontFamily: theme.typography.fontFamily,
            color: theme.palette.black,
          }
        },
        '& .employee-info': {
          background: theme.palette.blue[300],
          padding: theme.spacing(1),
          minHeight: 'calc(100vh - 600px)',
          '& > .MuiTypography-root': {
            fontFamily: theme.typography.fontFamily,
            color: theme.palette.black,
            'span': {
              color: theme.palette.corporateBlue
            }
          }
        },
        '& .status-info': {
          background: theme.palette.blue[100],
          marginTop: theme.spacing(.5),
          minHeight: '140px',
          '& .MuiTypography-root': {
            fontFamily: theme.typography.fontFamily,
            color: theme.palette.black,
          },
        },
        '& .status-wrapper': {
          color: theme.palette.error.main,
          margin: theme.spacing(1),
          '& > span': {
            color: theme.palette.black,
            marginRight: theme.spacing(1),
            '&:last-of-type': {
              color: theme.palette.corporateBlue,
              '&.available': {
                color: theme.palette.green[50]
              },
              '&.not-available': {
                color: theme.palette.red.A700
              }
            },
          },
          '&.available': {
            color: theme.palette.green[50]
          },
          '&.not-available': {
            color: theme.palette.red.A700
          },
          '&:last-of-type::after': {
            display: 'none'
          },
          'span': {
            margin: 0,
            '&.status': {
              marginRight: theme.spacing(1),
            }
          }
        }
      }),
    },
    {
      props: { variant: 'container' },
      style: ({ theme }) => ({
        background: theme.palette.coldWhite,
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        overflow: 'auto',
        borderRadius: '8px',
      })
    },
    {
      props: { variant: 'form-label' },
      style: ({ theme }) => ({
        color: theme.palette.corporateBlue,
        fontWeight: 'bold'
      })
    }
  ],
  styleOverrides: {
    root: {
      // override default font size, 1rem
      fontSize: '16px',
    },
  },
};

export default typographyTheme;
